/**
 * Vor- und Nachname eines Mitglieds korrigieren.
 *
 * Die E-Mail steht bewusst nicht zur Auswahl: sie ist die Anmeldung, und der Endpoint nimmt sie
 * gar nicht entgegen. Eine Adressänderung wäre ein Kontowechsel und braucht einen eigenen Weg.
 */
import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FormField,
  Input,
} from '@/shared/components';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  email: string;
  firstName: string;
  lastName: string;
  loading?: boolean;
  onSubmit: (name: { firstName: string; lastName: string }) => void;
}

export function UserNameDialog({
  open,
  onOpenChange,
  email,
  firstName,
  lastName,
  loading,
  onSubmit,
}: Props) {
  const [first, setFirst] = useState(firstName);
  const [last, setLast] = useState(lastName);

  useEffect(() => {
    if (open) {
      setFirst(firstName);
      setLast(lastName);
    }
  }, [open, firstName, lastName]);

  const trimmedFirst = first.trim();
  const trimmedLast = last.trim();
  const unchanged = trimmedFirst === firstName.trim() && trimmedLast === lastName.trim();
  const incomplete = trimmedFirst.length === 0 || trimmedLast.length === 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Name bearbeiten</DialogTitle>
          <DialogDescription>{email}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <div className="grid gap-4 sm:grid-cols-2">
            <FormField label="Vorname" required>
              <Input
                value={first}
                disabled={loading}
                autoComplete="off"
                onChange={(event) => setFirst(event.target.value)}
              />
            </FormField>
            <FormField label="Nachname" required>
              <Input
                value={last}
                disabled={loading}
                autoComplete="off"
                onChange={(event) => setLast(event.target.value)}
              />
            </FormField>
          </div>
          <p className="text-ink-soft mt-3 text-xs">
            Die E-Mail-Adresse ist die Anmeldung und lässt sich hier nicht ändern.
          </p>
        </DialogBody>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>
            Abbrechen
          </Button>
          <Button
            variant="brand"
            loading={loading}
            disabled={loading || unchanged || incomplete}
            onClick={() => onSubmit({ firstName: trimmedFirst, lastName: trimmedLast })}
          >
            Speichern
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
